import { FC } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import { parseISO } from "date-fns";
import {
    ReportVersionTransition,
    useReportVersionQuery,
    useTransitionReportVersionStatusMutation,
} from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { reportVersionStatusTransitionLabel, reportVersionStatusTransitionWarning } from "app/api/graph/strings";
import { formatDate } from "app/util/format";

type Props = {
    reportVersionId: number;
    transition: ReportVersionTransition;
    onTransition?: () => void;
};

export const TransitionReportVersionForm: FC<Props> = ({ reportVersionId, transition, onTransition }) => {
    const { data } = useReportVersionQuery({
        variables: { versionId: reportVersionGraphId(reportVersionId) },
    });
    const reportVersion = data?.reportVersion;
    const testPerformedFrom =
        reportVersion?.testPerformedFrom != null ? parseISO(reportVersion.testPerformedFrom) : undefined;
    const testPerformedTo =
        reportVersion?.testPerformedTo != null ? parseISO(reportVersion.testPerformedTo) : undefined;
    const now = new Date();
    console.log(testPerformedFrom, testPerformedTo, now);

    const [handleTransition, { loading, error }] = useTransitionReportVersionStatusMutation({
        variables: {
            reportVersionId: reportVersionGraphId(reportVersionId),
            transition,
        },
    });

    return (
        <div>
            {error ? <Alert variant="danger">{error.message}</Alert> : null}
            <Alert variant="warning">{reportVersionStatusTransitionWarning(transition)}</Alert>

            {transition === ReportVersionTransition.StartTest &&
                testPerformedFrom !== undefined &&
                now < testPerformedFrom && (
                    <Alert variant="warning">
                        The test is not scheduled to start until {formatDate(testPerformedFrom)}.
                    </Alert>
                )}

            {transition === ReportVersionTransition.CompleteTest &&
                testPerformedTo !== undefined &&
                now < testPerformedTo && (
                    <Alert variant="warning">
                        The test is not scheduled to end until {formatDate(testPerformedTo)}.
                    </Alert>
                )}

            <Button
                type="submit"
                variant="warning"
                disabled={loading}
                onClick={() => handleTransition().then(() => onTransition?.())}
            >
                {reportVersionStatusTransitionLabel(transition)}
            </Button>
        </div>
    );
};
